import React, { useState } from 'react'
import LegalModal from './LegalModal'

const Footer = () => {
  const currentYear = new Date().getFullYear()
  const [legalModal, setLegalModal] = useState(null)

  return (
    <>
    <footer className="footer">
      <div className="container">
        <div className="footer-bottom-content">
          <p>&copy; {currentYear} TalentHouse. All rights reserved.</p>
          <div className="footer-legal-links">
            <button onClick={() => setLegalModal('privacy')}>Privacy Policy</button>
            <button onClick={() => setLegalModal('terms')}>Terms of Service</button>
            <button onClick={() => setLegalModal('cookies')}>Cookie Policy</button>
          </div>
        </div>
      </div>
    </footer>

    {legalModal && (
      <LegalModal type={legalModal} onClose={() => setLegalModal(null)} />
    )}
    </>
  )
}

export default Footer
